import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

// Stok → Talep Oluştur: ürün + beden/varyant + miktar ile Hazır Ürün Alımı'na açık satın alma talebi (ST).
// Tedarikçi seçilmez/atanmaz, PO oluşmaz, stok değişmez. row.sizes varsa çok bedenli (ürün bazlı) mod.
export function StockReplenishDialog({ row, onClose }) {
  const [qty, setQty] = useState({});
  const [saving, setSaving] = useState(false);
  useEffect(() => { setQty({}); }, [row]);
  const sizes = row?.sizes || (row ? [{ variant_id: row.variant_id || "", label: row.label, available: row.available }] : []);
  const lines = sizes.map((s) => ({ variant_id: s.variant_id || "", quantity: Number(qty[s.variant_id || ""] || 0) })).filter((l) => l.quantity > 0);
  const submit = async () => {
    if (saving || !lines.length) return;
    setSaving(true);
    try {
      const { data } = await api.post("/purchase-requests/stock-replenish", { product_id: row.product_id, lines });
      toast.success(`Talep oluşturuldu (${data.request_no}) — Satın Alma İhtiyaçları › Hazır Ürün Alımı'na düştü`);
      onClose();
    } catch (e) { toast.error(formatApiError(e)); } finally { setSaving(false); }
  };
  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm bg-slate-900 border-slate-800" data-testid="replenish-dialog">
        <DialogHeader>
          <DialogTitle className="text-sm">Talep Oluştur — {row?.product_name} {!row?.sizes && row?.label ? `· ${row.label}` : ""}</DialogTitle>
        </DialogHeader>
        <div className="text-xs text-slate-400">Talep Hazır Ürün Alımı'na düşer; tedarikçi satın alma aşamasında seçilir. Stok değişmez.</div>
        <div className="max-h-72 overflow-y-auto space-y-1.5">
          {sizes.map((s) => (
            <div key={s.variant_id || "std"} className="flex items-center gap-2">
              <span className="flex-1 text-xs text-slate-200 truncate">{s.label || "Standart"}
                <span className="ml-1 font-mono text-[10px] text-emerald-400">kul. {s.available ?? 0}</span>
              </span>
              <Input type="number" min="0" value={qty[s.variant_id || ""] || ""} placeholder="Adet"
                onChange={(e) => setQty((p) => ({ ...p, [s.variant_id || ""]: e.target.value }))}
                className="w-24 bg-slate-950 border-slate-800 rounded-sm h-8 text-right" data-testid={`replenish-qty-${s.variant_id || "std"}`} />
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="rounded-sm" data-testid="replenish-cancel-btn">İptal</Button>
          <Button onClick={submit} disabled={saving || !lines.length} className="rounded-sm bg-blue-600 hover:bg-blue-500" data-testid="replenish-submit-btn">
            {saving && <Loader2 className="w-3.5 h-3.5 mr-1 animate-spin" />} Talep Oluştur
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
